export enum RequiredActionResourceTypes {
  TRIP = 'Trip',
  WORK_ORDER = 'WorkOrder',
  INVOICE = 'Invoice',
  PROPOSAL = 'Proposal',
  PURCHASE_ORDER = 'PurchaseOrder'
}
